import withStyles from '@mui/styles/withStyles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Dispatch, Action } from 'redux';
import i18next from 'i18next';
import { FirmwareService, getDefaultTableProperties } from '../../../services';
import { ModalVariants, Key, SubdomainRoutePath } from '../../../common/types';
import { storeOpenModal } from '../../../store/actions/modal';
import { tableProperties, itemIcons, TableNames } from '../../../common/constants';
import { SnackbarUtils } from '../../../components';
import { ListBase, ListBaseStyles, ListBaseProps, ListBaseState } from '../../baseClasses/ListBase';

type _Props = {
  openModal: (callback: () => any) => void;
};
type Props = ListBaseProps<_Props>;

type State = ListBaseState;

class KeyView extends ListBase<_Props> {
  state: State = {
    initLoaded: false,
    loading: false,
    items: [],
    activeTabIndex: 0,
    predefinedFilters: [],
    properties: [],
  };

  constructor(props: Props) {
    super(props);
    // Init static variables
    this.accessControlSection = 'key';
    this.title = i18next.t('keys');
    this.icon = itemIcons.key;
    this.idKey = 'keyId';
    this.tableConfig = {
      tableProperties: getDefaultTableProperties(tableProperties(TableNames.key)),
      emptyTitle: 'form.empty.keys',
      rowActions: [
        {
          title: 'action.delete',
          action: async (key: Key) => this.setState({ dialogOpen: key.keyId }),
        },
      ],
    };
    this.dialogConfig = {
      title: i18next.t('action.delete'),
      description: i18next.t('description.delete.key'),
      continueTitle: i18next.t('action.delete'),
      onClose: () => this.setState({ dialogOpen: undefined }),
      onContinue: () => this.state.dialogOpen && this.removeKey(this.state.dialogOpen),
    };
    this.fabConfig = [
      {
        title: i18next.t('action.createKey'),
        action: () => this.props.openModal(this.reloadList),
        icon: itemIcons.key,
        tryAccessRight: ['key', 'create'],
      },
    ];

    // Functions
    this.getUrlPathForItem = SubdomainRoutePath.key;
  }

  componentDidMount = async () => {
    this.service = await FirmwareService.create();
    this.list = this.service!.key.list;
    this.setState({ initLoaded: true });
  };

  removeKey = async (keyId: string): Promise<void> => {
    try {
      await this.service.key.del(keyId);
      SnackbarUtils.success(i18next.t('success.delete.key'));
      if (!this.isUnmounted) {
        const items = this.state.items.filter((item: Key) => item.keyId !== keyId);
        this.setState({ items });
      }
    } catch (e) {
      const error: any = e;
      SnackbarUtils.error(
        (error.response && error.response.data && error.response.data.message) || i18next.t('error.tryAgain'),
      );
      if (!this.isUnmounted) this.setState({ loading: false });
    }
  };
}

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  openModal: (callback: () => any) => dispatch(storeOpenModal(ModalVariants.CreateKeyMC, { callback })),
});

export default withStyles(ListBaseStyles)(withRouter(connect(null, mapDispatchToProps)(KeyView)));
